import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n#DIVIDER\n\\*------------------------------------*/\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --width: var(--leaf-border-width-default);\n}\n\n.leaf-c-divider {\n  background: var(--leaf-color-border-default);\n}\n\n.leaf-c-divider--horizontal {\n  display: block;\n  height: var(--width);\n  width: 100%;\n}\n\n.leaf-c-divider--vertical {\n  display: inline-block;\n  height: 100%;\n  width: var(--width);\n}\n\n.leaf-c-divider--subtle {\n  background: var(--leaf-color-border-brand-subtle);\n}\n\n.leaf-c-divider--inverted {\n  background: var(--leaf-color-border-knockout);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafDivider = class _LeafDivider extends LeafElement {
  constructor() {
    super(...arguments);
    this.variant = "horizontal";
    this.inverted = false;
    this.brandsubtle = false;
  }
  render() {
    const componentClassNames = {
      "leaf-c-divider": true,
      "leaf-c-divider--horizontal": this.variant === "horizontal",
      "leaf-c-divider--vertical": this.variant === "vertical",
      "leaf-c-divider--subtle": this.brandsubtle && !this.inverted,
      "leaf-c-divider--inverted": this.inverted
    };
    return html`<div class=${classMap(componentClassNames)}></div> `;
  }
};
_LeafDivider.styles = unsafeCSS(styles);
let LeafDivider = _LeafDivider;
__decorateClass([
  property()
], LeafDivider.prototype, "variant", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], LeafDivider.prototype, "inverted", 2);
__decorateClass([
  property({ type: Boolean, reflect: true, attribute: "brand-subtle" })
], LeafDivider.prototype, "brandsubtle", 2);
export {
  LeafDivider
};
//# sourceMappingURL=divider.component.js.map
